import React from "react";
import { css } from "emotion";
import headerShaded from "../../../src/assets/images/header-shadow2.png";
import TitleBlock from "../TitleBlock";
import TopRow from "../header/TopRow";

const EmbedMobileHeader = () => {
  return (
    <div className={container}>
      <TopRow />
      <TitleBlock
        title="Embed Spotlight"
        subtitle="A plug and play solution that takes seconds"
      />
    </div>
  );
};

export default EmbedMobileHeader;

const container = css`
  background-image: url(${headerShaded});
  background-position: center bottom;
  min-height: 250px;
  background-repeat: no-repeat;
  background-size: 100% auto;
`;
